import { Component, Input } from 'angular-ts-decorators';
import { faCopy } from '@fortawesome/pro-solid-svg-icons';
/**
 * Renders button that takes a text binding which once the button
 * is clicked the text will be copied to the users clipboard
 */
@Component({
  selector: 'swCopyClipboard',
  template: require('./sw-copy-clipboard.html').default,
})
export class SwCopyClipboardComponent {
  @Input() text: string;

  copyText: string;
  faCopy = faCopy;

  constructor(
    private $translate: ng.translate.ITranslateService,
    private $timeout: ng.ITimeoutService,
    private Clipboard,
  ) {
    'ngInject';

    this.copyText = $translate.instant('core.copy_text');
  }

  copy($event) {
    this.copyText = this.$translate.instant('core.copied_text');

    new this.Clipboard($event.target);
    this.$timeout(() => {
      this.copyText = this.$translate.instant('core.copy_text');
    }, 1000);
  }
}
